import {
  getPostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletions201 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

export const useBulkDeletionUser = (
  threeLetterCode: string,
  options?: {
    onSuccess?: (data: PostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletions201) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsUsersBulkDeletionsMutationFetcher(threeLetterCode),
    options
  );
};
